/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
  //  var container = event.target;
    if (variant) {
      // ... update some element on the page

      // update SKU
      // var newSku = '';
      // var hideSku = true;

      // if (variant) {
      //   if (variant.sku) {
      //     newSku = variant.sku;
      //     hideSku = false;
      //   }

      //   document.querySelectorAll('[data-sku]').forEach(el => {
      //     el.classList.toggle('is-hidden', hideSku);
      //     el.querySelector('[data-sku-id]').textContent = newSku;
      //   });
      // }
    }
  });

  const productEnquireBtn = document.querySelector('[data-product-enquire]');
  if(productEnquireBtn) {
    productEnquireBtn.addEventListener('click', function(event) {
      event.preventDefault();
      const productEnquireForm = document.querySelector('[data-product-form-enquire]');
      productEnquireForm.classList.add('active');
      productEnquireBtn.classList.add('hidden');

      const productEnquireFormSuccess = document.querySelector('[data-product-enquire-success]');
      productEnquireFormSuccess.parentElement.removeChild(productEnquireFormSuccess);
    })
  }

  const productNotifyBtn = document.querySelector('[data-product-notify]');
  if(productNotifyBtn) {
    productNotifyBtn.addEventListener('click', function(event) {
      event.preventDefault();
      const productNotifyForm = document.querySelector('[data-product-form-notify]');
      productNotifyForm.classList.add('active');

      const productEnquireNotifySuccess = document.querySelector('[data-product-notify-success]');
      productEnquireNotifySuccess.parentElement.removeChild(productEnquireNotifySuccess);
    })
  }

  const tosCheckbox = document.getElementById('tos_checkbox');
  const checkoutBtn = document.querySelector('.btn.checkout__button');
  if (tosCheckbox) {
    tosCheckbox.addEventListener('change', function() {
      if (tosCheckbox.checked == true)
        checkoutBtn.removeAttribute('disabled');
      else
        checkoutBtn.setAttribute('disabled', 'disabled');
    });
  }

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // *** GOOGLE MAP *** //
  var markers = new Array();

  function setMarkers(map) {

    var locations = [
      [
        'Burma Capucines',
        48.8709239,
        2.3329469,
        2,
        '8, boulevard des Capucines 75009 PARIS',
        'TEL : 00 33 1 42 66 21 51',
        'capucines@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h45'
      ],
      [
        'Burma François Ier',
        48.8690246,
        2.3033302,
        4,
        '50, rue François Ier 75008 PARIS',
        'TEL : 00 33 1 47 23 70 93',
        'francois1er@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'
      ],
      [
        'Burma Faubourg',
        48.8702664,
        2.3179476,
        6,
        '72, rue du Faubourg Saint-Honoré 75008 PARIS',
        'TEL : 00 33 1 42 65 18 02',
        'faubourg@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'
      ],
      [
        'Burma Saint Honoré',
        48.8661135,
        2.3298543, 5,
        '346, rue Saint-Honoré 75001 PARIS',
        'TEL : 00 33 1 42 96 08 42',
        'sthonore@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'

      ],
      [
        'Burma Cannes',
        43.5511813,
        7.0182417,
        8,
        '20, boulevard de la Croisette 06400 CANNES',
        'TEL : 00 33 4 93 68 67 20',
        'cannes@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'
      ],
      [
        'Burma Monaco',
        43.73333,
        7.41667,
        10,
        '17, avenue des Spélugues - Galerie Métropole - niveau 1 - Boutique 13 98000 MONACO',
        'TEL : 00 377 97 98 33 19',
        'monaco@bijouxburma.com',
        'Ouvert du lundi au samedi',
        'De 10h30 à 18h30'
      ],
      [
        'Burma Genève',
        46.2034142,
        6.1505978,
        12,
        '90, rue du Rhône 1204 GENEVE SUISSE',
        'TEL : 00 41 22 311 06 40',
        'geneve@bijouxburma.com',
        'Ouvert du lundi au vendredi <br>De 10h à 18h30',
        'Le samedi <br>De 10h à 17h'
      ],
      [
        'Burma Dubaï Mall',
        25.1970924,
        55.2790356,
        13,
        'D.M. Fashion Avenue Rez-de-chaussée - 316 DUBAI MALL UNITED ARAB EMIRATES',
        'TEL : 00 971 43 24 69 19',
        'dubaimall@bijouxburma.com',
        'Ouvert du dimanche au mercredi<br>De 10h à 23h',
        'Ouvert du jeudi au samedi<br>De 10h à minuit'
      ]
    ];

    var bounds = new google.maps.LatLngBounds();

    var infowindow;

    for (var i = 0; i < locations.length; i++) {

      var location = locations[i];
      var loc = new google.maps.LatLng(location[1], location[2]);

      var customMapListAddress = document.getElementById('custom_map_list_address');
      customMapListAddress.innerHTML +=
        '<div class="custom_map_list_address_item" data-markerid="' + i + '">' +
        '<div class="address_item_title">' + location[0] + '</div>' +
        '<div>' + location[4] + '<br>' + location[5] + '<br>' + location[6] + '<br><span class="map_color_item">' + location[7] + '</span><br>' + '<span class="map_color_item">' + location[8] + '</span></div>' +
        '</div>';

      bounds.extend(loc);

      var content =
        '<div class="map_window"><h3>' + location[0] + '</h3><br>' +
        '<p>' + location[4] + '<br>' + location[5] + ' <br>' + location[6] + ' <br>' + location[7] + '<br>' + location[8] + '</p>' +
        '</div>';


      var marker = new google.maps.Marker({

        position: {
          lat: location[1],
          lng: location[2]
        },
        map: map,
        animation: google.maps.Animation.DROP,
        title: location[0],
        zIndex: location[3]
      });

      markers.push(marker);

      google.maps.event.addListener(marker, 'click', (function (marker, content) {


        if (infowindow) {
          infowindow.close();
        }

        infowindow = new google.maps.InfoWindow({
          content: content
        });


        return function () {
          infowindow.setContent(content);
          infowindow.open(map, marker);


          map.setZoom(16);
          map.setCenter(marker.getPosition());
        };

      })(marker, content, infowindow));
    }

    map.fitBounds(bounds);
    map.panToBounds(bounds);

    var customMapAddressContainer = document.getElementById('custom_map_address_container');
    customMapAddressContainer.innerHTML += '<div class="custom_map_list_up_item">&#9650;</div><div class="custom_map_list_down_item">&#9660;</div>';

    var items = document.querySelectorAll('.custom_map_list_address_item');
    items.forEach(function(item) {
      item.addEventListener('click', function() {
        var markerId = this.getAttribute('data-markerid');
        alert(markerId);
        google.maps.event.trigger(markers[markerId], 'click');
      });
    });

  }

  function initMap() {

    const burmaLocation = document.getElementById('map_burma_location');
    if(burmaLocation) {
      var map = new google.maps.Map(burmaLocation, {
        zoom: 12,
        center: {
          lat: 48.8709239,
          lng: 2.3329469
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
          position: google.maps.ControlPosition.TOP_LEFT
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        scaleControl: false,
        streetViewControl: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        fullscreenControl: true
      });

      setMarkers(map);
    }

  }

  function toggleBounce(marker) {

    if (marker.getAnimation() !== null) {

      marker.setAnimation(null);
    }
    else {

      marker.setAnimation(google.maps.Animation.BOUNCE);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function () { initMap(); }, 1000);
  });
})();
